import type { ViewportBreakpoints } from './getBreakpoints';

export enum ViewportType {
  MOBILE = 'viewportType/mobile',
  TABLET = 'viewportType/tablet',
  DESKTOP = 'viewportType/desktop',
}

/**
 * Matches viewport constant based on the given viewport width and a set of breakpoints.
 */
function getViewportType(
  viewportWidth: number,
  breakpoints: ViewportBreakpoints
): ViewportType {
  if (viewportWidth >= breakpoints.desktopMinWidth) {
    return ViewportType.DESKTOP;
  }

  if (viewportWidth >= breakpoints.tabletMinWidth) {
    return ViewportType.TABLET;
  }

  return ViewportType.MOBILE;
}

export { getViewportType };
